import { JsonSchemaValidator } from "@common/json-schema-validator";
import { MixerConfig, MixerId, RecordingObjectPrefix } from "../../interface";
import { mixerConfig, mixerId, recordingObjectPrefix } from "../../schema";

export class MixerRecordingPipeStartCmd {
  private static validation = JsonSchemaValidator.compile(
    MixerRecordingPipeStartCmd.validationSchema()
  );

  constructor(readonly value: MixerRecordingPipeStart) {
    this.value = JsonSchemaValidator.assert(
      MixerRecordingPipeStartCmd.validation,
      value
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["mixerId", "mixerConfig", "prefix"],
      properties: {
        mixerId,
        mixerConfig,
        prefix: recordingObjectPrefix
      },
      additionalProperties: false
    };
  }
}

interface MixerRecordingPipeStart {
  mixerId: MixerId;
  mixerConfig: MixerConfig;
  prefix: RecordingObjectPrefix;
}
